import React from "react";
import { PROMO_CODES_PATH } from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import {
  PROMO_CODES_ADD_PATH,
  PROMO_CODES_UPDATE_PATH,
  PROMO_CODES_ANALYTICS_PATH,
} from "utils/constants/paths";

const PromoCodes = Loadable(React.lazy(() => import("./View")));
const PromoCodesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);
const PromoCodesAnalytics = Loadable(
  React.lazy(() => import("./View/Analytics"))
);

export const PromoCodesRoute: IRouteItem = {
  path: PROMO_CODES_PATH,
  iconName: "Ticket",
  element: React.createElement(PromoCodes),
  name: "Promo codes",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
  children: [
    {
      name: "Add / Update",
      path: PROMO_CODES_ADD_PATH,
      element: React.createElement(PromoCodesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: PROMO_CODES_UPDATE_PATH,
      element: React.createElement(PromoCodesAddOrUpdate),
      showInDrawer: false,
    },
    {
      name: "Analytics",
      path: `${PROMO_CODES_ANALYTICS_PATH}/:id`,
      element: React.createElement(PromoCodesAnalytics),
      showInDrawer: false,
    },
  ],
};
